import React from "react";
import { Navigate, useParams, useSearchParams } from "react-router-dom";

/**
 * Keeps old /admin/bookings/:bookingId links working by forwarding to the
 * current /admin/hosts/bookings/:bookingId route, preserving the query string.
 *
 * Shared by App.tsx and app/AdminPortalApp.tsx, which mount parallel admin
 * route trees. They previously held identical copies of this component - and of
 * the sibling /admin/bookings and /admin/host-events redirects, where the same
 * relative-path bug had to be fixed twice.
 *
 * The target is absolute on purpose: a relative `to` resolves against the
 * route's own path, which is what produced /admin/bookings/hosts/bookings.
 */
const LegacyAdminBookingDetailRedirect: React.FC = () => {
  const { bookingId } = useParams<{ bookingId: string }>();
  const [searchParams] = useSearchParams();
  const q = searchParams.toString();
  return (
    <Navigate
      to={`/admin/hosts/bookings/${bookingId || ""}${q ? `?${q}` : ""}`}
      replace
    />
  );
};

export default LegacyAdminBookingDetailRedirect;
